import React from 'react';

import { withRouter, Link } from 'react-router-dom';

import Button from '../../artzu-ui/src/Button';
import Modal from '../../artzu-ui/src/Modal';

const BookingPromptModal = ({ open, closeModal, history }) => (
  <Modal open={open}>
    <div className="report__modal__container">
      <div className="report__modal__container__message report__modal__container__message--bold">
        Please visit My Bookings to find the specific time and date of the booking for which you would like to make an
        incident report.
      </div>
      <div>
        <Link to="./dashboard">
          <Button label="Okay" />
        </Link>
      </div>
    </div>
  </Modal>
);

export default withRouter(BookingPromptModal);



// WEBPACK FOOTER //
// ./src/components/Report/BookingPromptModal.js